.identityCard {
  display: flex;
  align-items: center;
  gap: var(--space-5);
  padding: var(--space-6);
  flex-wrap: wrap;
}

.identityText {
  min-width: 0;
  flex: 1;
}

.identityName {
  font-size: var(--text-xl);
  font-weight: var(--weight-semibold);
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
}

.identityEmail {
  margin-top: var(--space-1);
  color: var(--text-secondary);
  overflow-wrap: anywhere;
}

.identityBadges {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
  margin-top: var(--space-3);
}

.readonlyNote {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-top: 1px solid var(--border-subtle);
  background: var(--bg-inset);
  font-size: var(--text-xs);
  line-height: var(--leading-relaxed);
  color: var(--text-secondary);
}

.readonlyIcon {
  color: var(--text-tertiary);
  flex-shrink: 0;
  margin-top: 2px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--space-5);
  align-items: start;
}

.full {
  grid-column: 1 / -1;
}

.rows {
  display: grid;
  gap: var(--space-4);
}

.row {
  display: grid;
  /* A narrow label column: the values here are long (emails, ids, formatted
     dates) and every pixel the label gives up is one fewer mid-word break. */
  grid-template-columns: minmax(88px, 116px) minmax(0, 1fr);
  gap: var(--space-3);
  align-items: baseline;
}

.label {
  font-size: var(--text-2xs);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-wider);
  text-transform: uppercase;
  color: var(--text-tertiary);
}

.value {
  color: var(--text-primary);
  overflow-wrap: anywhere;
}

.absent {
  color: var(--text-tertiary);
  font-style: italic;
}

.mono {
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  color: var(--text-secondary);
  overflow-wrap: anywhere;
}

.themeRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  flex-wrap: wrap;
}

.themeText {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  max-width: 44ch;
}

.danger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  flex-wrap: wrap;
}

@media (max-width: 560px) {
  .row {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--space-1);
  }
}
